import * as React from 'react';
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

export interface IGridDetailCardProps {
    rowIndex : string;
    activeRow : string;
    detailsLabel : string;
    onCloseAllDetailCards : () => any;
}

export const GridDetailCard = (props: IGridDetailCardProps) => {
    return <Card className="mijn-fnv-grid__column col-auto mijn-fnv-grid__card mijn-fnv-grid__collapse-detail-button w-auto">
    <Card.Header className="mijn-fnv-grid__card-header">
      <Accordion.Toggle
        as={Button}
        variant="link"
        eventKey={props.rowIndex}
        onClick={(event) => {
          if (props.activeRow == props.rowIndex) {
            props.onCloseAllDetailCards();
          }
        }}
        className={"mijn-fnv-grid__btn-link " + (props.activeRow == props.rowIndex ? "mijn-fnv-grid__btn-link--active" : "")}                        
      >
        <span className="mijn-fnv-grid__details-label">{props.detailsLabel}</span>
        <span className="icon icon-open-chevron-down mijn-fnv-grid__details-icon"></span>
      </Accordion.Toggle>
    </Card.Header>                    
  </Card>;
};